package nl.volleyplanner.web.controller

import kotlinx.browser.document
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.format
import kotlinx.dom.addClass
import kotlinx.dom.removeClass
import kotlinx.html.*
import kotlinx.html.dom.create
import kotlinx.html.js.onClickFunction
import nl.volleyplanner.api.auth.AuthLevel
import nl.volleyplanner.api.backend_jobs.JobType
import nl.volleyplanner.api.system.RepositoryCacheStats
import nl.volleyplanner.extensions.now
import nl.volleyplanner.web.DATE_TIME_FORMAT
import nl.volleyplanner.web.VolleyPlannerApplication
import nl.volleyplanner.web.base.*
import nl.volleyplanner.web.base.WebPageController
import nl.volleyplanner.web.component.backend_jobs.JobFlowComponent
import nl.volleyplanner.web.launchAsync
import org.w3c.dom.HTMLButtonElement
import org.w3c.dom.HTMLElement

class AdminController : RootPageController() {
    override val name = "AdminController"
    override val title = "Admin"
    override val path = "/admin"
    override val requiredAuthLevel = AuthLevel.AdminUser
    override val childPages: List<WebPageController> = emptyList()

    val cacheStatsState = MutableStateFlow<List<RepositoryCacheStats>?>(null)

    override fun createRuntimeInstance() = AdminController()

        inner class CacheComponent : HTMLComponent() {
        override fun render(consumer: TagConsumer<HTMLElement>): HTMLElement {
            return consumer.div {
                if (cacheStatsState.value == null) { spinner() }
                else {
                    button(classes = "btn btn-light btn-sm me-2") {
                        onClickFunction = { event ->
                            launchAsync { VolleyPlannerApplication.volleyplannerApiClient.getCacheStats() }
                                .onComplete { cacheStatsState.value = it }
                        }
                        +"Verversen"
                    }
                    table(classes = "table table-striped table-hover") {
                        thead {
                            tr {
                                th(scope = ThScope.col) { +"Repository" }
                                th(scope = ThScope.col) { +"Cache" }
                                th(scope = ThScope.col) { +"Size" }
                                th(scope = ThScope.col) { +"Hit Count" }
                                th(scope = ThScope.col) { +"Miss Count" }
                                th(scope = ThScope.col) { +"Load Success Count" }
                                th(scope = ThScope.col) { +"Load Failure Count" }
                                th(scope = ThScope.col) { +"Total Load Time" }
                                th(scope = ThScope.col) { +"Eviction Count" }
                                th(scope = ThScope.col) { +"Eviction Weight" }
                            }
                        }
                        tbody(classes = "table-group-divider") {
                            val cacheStatsList = cacheStatsState.value!!
                            cacheStatsList.forEach { cacheStats ->
                                tr {
                                    th(scope = ThScope.row) {
                                        rowSpan = "2"
                                        +cacheStats.repositoryName

                                        button(classes = "btn btn-light btn-sm me-2") {
                                            onClickFunction = { event ->
                                                launchAsync {
                                                    VolleyPlannerApplication.volleyplannerApiClient.clearCache(cacheStats.repositoryName)
                                                    VolleyPlannerApplication.volleyplannerApiClient.getCacheStats()
                                                }.onComplete { cacheStatsState.value = it }
                                            }
                                            +"Legen"
                                        }
                                    }
                                    td { +"${cacheStats.idCacheStats.cacheName}" }
                                    td { +"${cacheStats.idCacheStats.estimatedSize}" }
                                    td { +"${cacheStats.idCacheStats.hitCount}" }
                                    td { +"${cacheStats.idCacheStats.missCount}" }
                                    td { +"${cacheStats.idCacheStats.loadSuccessCount}" }
                                    td { +"${cacheStats.idCacheStats.loadFailureCount}" }
                                    td { +"${cacheStats.idCacheStats.totalLoadTime}" }
                                    td { +"${cacheStats.idCacheStats.evictionCount}" }
                                    td { +"${cacheStats.idCacheStats.evictionWeight}" }
                                }
                                tr {
                                    td { +"${cacheStats.queryCacheStats.cacheName}" }
                                    td { +"${cacheStats.queryCacheStats.estimatedSize}" }
                                    td { +"${cacheStats.queryCacheStats.hitCount}" }
                                    td { +"${cacheStats.queryCacheStats.missCount}" }
                                    td { +"${cacheStats.queryCacheStats.loadSuccessCount}" }
                                    td { +"${cacheStats.queryCacheStats.loadFailureCount}" }
                                    td { +"${cacheStats.queryCacheStats.totalLoadTime}" }
                                    td { +"${cacheStats.queryCacheStats.evictionCount}" }
                                    td { +"${cacheStats.queryCacheStats.evictionWeight}" }
                                }
                            }
                        }
                    }
                }
            }
        }

        override suspend fun getState() = cacheStatsState
    }

    override suspend fun renderContent(): HTMLElement {
        launchAsync {
            VolleyPlannerApplication.volleyplannerApiClient.getCacheStats()
        }.onComplete { cacheStatsState.value = it }

        return document.create.div(classes = "container") {
            h2 { +"Admin" }
            component(
                JobFlowComponent(JobType.NevoboSync, listOf("recent_matches", LocalDateTime.now().format(
                    DATE_TIME_FORMAT)), "Sync Laatste Nevobo Uitslagen")
            )
            // Lelijk, I know. Maarja het is de admin pagina maar
            button(classes = "btn btn-primary btn-sm me-2") {
                onClickFunction = { event ->
                    (event.target as HTMLButtonElement).removeClass("btn-success")
                    (event.target as HTMLButtonElement).removeClass("btn-danger")
                    (event.target as HTMLButtonElement).removeClass("btn-primary")
                    (event.target as HTMLButtonElement).addClass("btn-secondary")
                    launchAsync {
                        VolleyPlannerApplication.volleyplannerApiPlannerClient.refreshCompetitionRulesets()
                    }.onComplete {
                        (event.target as HTMLButtonElement).addClass("btn-success")
                        (event.target as HTMLButtonElement).removeClass("btn-secondary")
                    }.onError {
                        (event.target as HTMLButtonElement).addClass("btn-danger")
                        (event.target as HTMLButtonElement).removeClass("btn-secondary")
                    }
                }
                +"Refresh rulesets"
            }

            component(CacheComponent())
        }
    }
}